/**
 * Screenshots for the public site: `src/assets/marketing/<name>.webp`, collected
 * at build time. A name with no file is simply absent.
 */

const FILES = import.meta.glob('../assets/marketing/*.webp', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

export const SHOTS: Record<string, string> = Object.fromEntries(
  Object.entries(FILES).map(([path, url]) => [path.replace(/^.*\/([^/]+)\.webp$/, '$1'), url])
);

export function hasShot(name: string): boolean {
  return name in SHOTS;
}
